import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ResponsiveRow } from "../../constants/layout.constants";
import { clearMessage } from "../../actions/message";
import { titleCase } from "../../util/util";
import { useEffect } from "react";
import history from "../../helpers/history";
import { modalClear } from "../../actions/modals";

export const Toast = ({simple}) => {
    const message = useSelector(state => state.message);
    const modals = useSelector(state => state.modals);
  const isAnyModalOpen = modals.openModals > 0;

  const dispatch = useDispatch();
  
  useEffect(() => {
    if (message.display) {
      const timer = setTimeout(() => {
        dispatch(clearMessage());
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [message.display, isAnyModalOpen, dispatch]);
  
  useEffect(() => {
    history.listen((location) => {
      dispatch(clearMessage());
      dispatch(modalClear());
    }) 
    }, [dispatch]
  );

  if (!message.display) {
    return null;
  }

  if(isAnyModalOpen || simple){ 
    return (
      <Alert severity={message.type} onClose={() => dispatch(clearMessage())}>
        <AlertTitle>{titleCase(message.type)}</AlertTitle>
        {message.message}
      </Alert>
    );
  }

  return (
    <ResponsiveRow
      sx={{
        position: "relative",
        zIndex: 200,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "start",
        height: "0px",
        padding: 0,
        margin: 0,
        width: "100%",
      }}
    >
      <Alert
        sx={{
          width: "100%",
          height: "auto",
          position: "absolute",
          top: 0,
          right: 0,
          minWidth: "300px",
          maxWidth: "fit-content",
        }}
        severity={message.type}
        onClose={() => dispatch(clearMessage())}
        closeText="Dismiss"
      >
        <AlertTitle>{titleCase(message.type)}</AlertTitle>
        {message.message}
      </Alert>
    </ResponsiveRow>
  );
}